module.exports = __webpack_public_path__ + "static/img/brees-2019-slide-2.94ec29d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2019-slide-2.jpg
// module id = sPUs
// module chunks = 1